export const MEASURE_DIMENSIONS_RESET_STATE = 'MEASURE_DIMENSIONS_RESET_STATE';
export const MEASURE_DIMENSIONS_CURRENT_ITEM = 'MEASURE_DIMENSIONS_CURRENT_ITEM';

export const MEASURE_DIMENSIONS_REQUEST_LOADING = 'MEASURE_DIMENSIONS_REQUEST_LOADING';
export const MEASURE_DIMENSIONS_REQUEST_SUCCESS = 'MEASURE_DIMENSIONS_REQUEST_SUCCESS';
export const MEASURE_DIMENSIONS_REQUEST_FAILED = 'MEASURE_DIMENSIONS_REQUEST_FAILED';

export const MEASURE_DIMENSIONS_CURRENT_ACTION = 'MEASURE_DIMENSIONS_CURRENT_ACTION';
export const MEASURE_DIMENSIONS_RESET_ACTION = 'MEASURE_DIMENSIONS_RESET_ACTION';